import {
  createAdminSitePage,
  getAdminSitePages,
  getPublicPage,
  updateAdminSitePage,
} from "../api";

export const MAINTENANCE_MODE_STORAGE_KEY = "advahini:maintenance-mode";
export const MAINTENANCE_MODE_EVENT = "advahini:maintenance-mode-change";
const MAINTENANCE_PAGE_SLUG = "maintenance-mode";

export const isMaintenanceModeEnabled = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(MAINTENANCE_MODE_STORAGE_KEY) === "enabled";
};

export const setMaintenanceModeEnabled = (enabled) => {
  if (typeof window === "undefined") return;
  if (enabled) {
    window.localStorage.setItem(MAINTENANCE_MODE_STORAGE_KEY, "enabled");
  } else {
    window.localStorage.removeItem(MAINTENANCE_MODE_STORAGE_KEY);
  }
  window.dispatchEvent(
    new CustomEvent(MAINTENANCE_MODE_EVENT, {
      detail: { enabled: Boolean(enabled) },
    })
  );
};

const readEnabledFromPage = (page) => {
  const raw = String(page?.excerpt || page?.content_html || "").trim().toLowerCase();
  if (raw === "enabled") return true;
  if (raw === "disabled") return false;
  return raw.includes("\"enabled\":true");
};

export const fetchMaintenanceModeEnabled = async () => {
  try {
    const response = await getPublicPage(MAINTENANCE_PAGE_SLUG);
    const enabled = readEnabledFromPage(response.data);
    setMaintenanceModeEnabled(enabled);
    return enabled;
  } catch {
    return isMaintenanceModeEnabled();
  }
};

export const saveMaintenanceModeEnabled = async (enabled) => {
  const payload = {
    title: "Maintenance Mode",
    slug: MAINTENANCE_PAGE_SLUG,
    page_type: "system",
    excerpt: enabled ? "enabled" : "disabled",
    content_html: JSON.stringify({ enabled: Boolean(enabled) }),
    meta_title: "Maintenance Mode",
    meta_description: "Controls the public Advahini maintenance page.",
    is_published: true,
  };

  const pagesResponse = await getAdminSitePages();
  const existingPage = (pagesResponse.data || []).find(
    (page) => String(page?.slug || "") === MAINTENANCE_PAGE_SLUG
  );

  if (existingPage?.id) {
    await updateAdminSitePage(existingPage.id, payload);
  } else {
    await createAdminSitePage(payload);
  }

  setMaintenanceModeEnabled(enabled);
  return enabled;
};
